import { Injectable } from '@angular/core';

import { Http, URLSearchParams, Headers } from '@angular/http';
import 'rxjs/Rx';
import { URL_SERVICIOS } from '../../conf/url.servicios';
import { Router } from '@angular/router';

@Injectable()
export class CompraService {

//Venta
productos:any[]=[];


  constructor(private router: Router, private http: Http) {
    this.router.navigate(['/perfil']);
  }


  agregarProducto(producto:any){
    //poner produrcto real
    this.productos.push(producto);
  }

}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/services/compra.service.ts